module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-Bold-5e8590a7c7343d01e240d52fbc2c32ad.otf";